import { Component, Input, OnInit } from '@angular/core';
import { ConfigServiceProvider } from "../../../modules/core/services/config-service/config-service";
import { PlayerServiceProvider } from "../../../modules/core/services/player-service/player-service";
import {User, UsersServiceProvider} from "../../../modules/core/services/users-service/users-service";
import { KpiServiceProvider } from "../../../modules/ranking/services/kpi-service/kpi-service";
import { RankingServiceProvider } from "../../../modules/ranking/services/ranking-service/ranking-service";

@Component({
  selector: 'ranking-comparision',
  templateUrl: 'ranking-comparision.html'
})
export class RankingComparisionComponent implements OnInit {

  filters = { ranking: '', user: '' };
  rankingDefinition: any = {};
  ranking: any = {};
  kpiDefinitions: any = {};
  player: User;
  currentRanking;
  currentKpis;
  loading: boolean = true;

  @Input() filterRanking;
  @Input() filterUser;
  @Input() opponentUser;

  constructor(public configService: ConfigServiceProvider, private playerService: PlayerServiceProvider, private userService: UsersServiceProvider, private kpiService: KpiServiceProvider, private rankingService: RankingServiceProvider) {
  }

  ngOnInit() {
    this.filters.ranking = this.filterRanking;
    this.filters.user = this.filterUser;
    this.loading = true;

    Promise.all([
      this.playerService.getPlayer(),
      this.kpiService.getKpiDefinitions(),
      this.rankingService.getRankingDefinitions(),
      this.rankingService.getRankings(),
    ]).then(response => {
      this.player = response[0];
      this.kpiDefinitions = response[1];
      this.rankingDefinition = this.getRankingById(this.filters.ranking, response[2]);
      this.ranking = response[3][this.filters.ranking];

      let currentRanking = this.ranking[this.player.id];
      if (!currentRanking) {
        currentRanking = this.ranking[this.opponentUser.id];
      }

      let rankingDate = new Date(currentRanking[0].date);

      let kpisHistory = this.rankingDefinition.params.kpis.sort((a, b) => {
        if (new Date(a.date_start).getTime() > new Date(b.date_start).getTime()) {
          return -1;
        }
        else if (new Date(a.date_start).getTime() < new Date(b.date_start).getTime()) {
          return 1;
        }
        else {
          return 0;
        }
      });

      this.currentKpis = {};
      for (let j = 0; j < kpisHistory.length; j++) {
        if (new Date(kpisHistory[j].date_start).getTime() <= new Date(rankingDate).getTime()) {
          this.currentKpis = kpisHistory[j];
          break;
        }
      }

      this.currentKpis.kpi.sort((a, b) => {
        let kpiA = this.getKpiById(a.kpiId);
        let kpiB = this.getKpiById(b.kpiId);

        if (kpiA && kpiB) {
          let priorityA = kpiA.params.priority;
          let priorityB = kpiB.params.priority;

          if (priorityA && priorityB) {
            return priorityB - priorityA;
          }
        }

        return b.multiplier - a.multiplier;
      });

      setTimeout(() => {
        this.loading = false;
      }, 350);
    })
  }

  getRankingById(id, rankingDefnitions) {
    for (let i = 0; i < rankingDefnitions.length; i++) {
      if (rankingDefnitions[i].id == id) {
        return rankingDefnitions[i];
      }
    }
    return null;
  }

  getKpiById(id) {
    for (let i = 0; i < this.kpiDefinitions.length; i++) {
      if (this.kpiDefinitions[i].id == id) {
        return this.kpiDefinitions[i];
      }
    }
    return null;
  };

  getPointDifference(ranking, kpiId: number, id1: number, id2: number): number {
    return Math.round(ranking[id1][0].params.kpis[kpiId].params.value) -
      Math.round(ranking[id2][0].params.kpis[kpiId].params.value);
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ranking-comparision/ranking-comparision.ts